import moment from 'moment';

export const MONTHS = moment.months().map((month, index) => {
  return { label: month, value: index + 1 };
});

export const DAYS = Array.from({ length: 31 }, (_, i) => {
  return { label: i + 1, value: i + 1 };
});

export const YEARS = Array.from({ length: 32 }, (_, i) => {
  return { label: new Date().getFullYear() - i, value: new Date().getFullYear() - i };
}).sort((a, b) => a.value - b.value);

export const splitInitialDob = (dob: string) => {
  // Date format is YYYY-MM-DD
  const parts = dob ? dob.split('-') : [];
  const year = parseInt(parts[0]);
  const month = parseInt(parts[1]);
  const day = parseInt(parts[2]);
  const monthLabel = MONTHS.find((m) => m.value === month)?.label;
  const initialYear = year ? { label: year, value: year } : { label: 0, value: 0 };
  const initialMonth = month ? { label: monthLabel, value: month } : { label: '', value: 0 };
  const initialDay = day ? { label: day, value: day } : { label: 0, value: 0 };

  return { initialDay, initialMonth, initialYear };
};

function toTimeZone(dateStr: string, timeZone: string) {
  return new Date(dateStr).toLocaleString('en-US', { timeZone: timeZone });
}

export function articleDate(dateStr: string) {
  const inHomeTimeZone = toTimeZone(dateStr, 'America/Los_Angeles');
  return moment(inHomeTimeZone).format('MMM D, YYYY H:mm A');
}
